export default {
    name: "Custom  Clearance",
    meta: {
        icon: "accessibility",
        expanded: true,
        auth: true
    },
    departmentName: "Client",
    finalPagePermision: "",
    children: [{
            name: "CC-Import Details",
            path: "/CCImport/clientCcImport",
            meta: {
                icon: "accessibility",
                auth: true
            },
            component: require("../component/clientDashboard/clientCcImport.vue"),
            finalPagePermision: "",

        },
        {
            name: "CC-Export Details",
            path: "/CCImport/clientCcExport",
            meta: {
                icon: "accessibility",
                auth: true
            },
            component: require("../component/clientDashboard/clientCCExportDetail.vue"),
            finalPagePermision: "",

        },


    ]
};


// WEBPACK FOOTER //
// ./src/sidebar/clientCCDash.js